import React from 'react';
import Slider from '../../../molecules/system/media/Slider';
import {
  getScreenshotAltText,
  getVideoAltText,
} from '../../../../utils/sharedFunc';

export const Media = ({
  category,
  media,
  systemName,
  small,
  handleDataLayer,
  thumbSize,
}) => {
  const mediaArray = media
    .map((mediaObj, i) => {
      if (
        ['VIDEO', 'PITCH'].includes(mediaObj.type) &&
        mediaObj.subType === 'YOUTUBE'
      ) {
        return {
          category,
          systemName,
          type: mediaObj.type,
          subType: mediaObj.subType,
          id: mediaObj.id,
          videoId: mediaObj.url,
          url: `https://img.youtube.com/vi/${mediaObj.url}/0.jpg`,
          alt: getVideoAltText(mediaObj, systemName),
          order: mediaObj.order,
        };
      }
      if (
        ['VIDEO', 'PITCH'].includes(mediaObj.type) &&
        mediaObj.subType === 'VIMEO'
      ) {
        return {
          category,
          systemName,
          type: mediaObj.type,
          subType: mediaObj.subType,
          id: mediaObj.id,
          videoId: mediaObj.url,
          url: mediaObj?.imageUrl,
          alt: getVideoAltText(mediaObj, systemName),
          order: mediaObj.order,
        };
      }
      if (mediaObj.type === 'SCREENSHOT') {
        return {
          category,
          systemName,
          type: mediaObj.type,
          subType: mediaObj.subType,
          id: mediaObj.id,
          url: `https://ik.imagekit.io/businesswith/tr:w-200,h-100,cm-pad_resize,dpr-2/screenshot/${mediaObj.url}`,
          urlLarge: `https://ik.imagekit.io/businesswith/tr:w-1600/screenshot/${mediaObj.url}`,
          alt:
            getScreenshotAltText(mediaObj, systemName) ||
            `Screenshot number ${i} for ${systemName}`,
          order: mediaObj.order,
        };
      }
      if (mediaObj.type === 'DOCUMENT') {
        return {
          category,
          systemName,
          type: mediaObj.type,
          subType: mediaObj.subType,
          id: mediaObj.id,
          url: `https://ik.imagekit.io/businesswith/tr:w-200,h-100,cm-pad_resize,dpr-2/document/${mediaObj.url}`,
          name: mediaObj.url,
          alt: mediaObj.altText,
          order: mediaObj.order,
        };
      }
      return mediaObj.type;
    })
    .sort((a) => {
      if (a.type === 'VIDEO') {
        return -1;
      }
      return 1;
    });

  if (!mediaArray) {
    return null;
  }

  return (
    <Slider
      media={mediaArray}
      small={small}
      thumbSize={thumbSize}
      handleDataLayer={handleDataLayer}
    />
  );
};
